import { addDoc, alertCollection, getDateNow } from '../config/firebase';
import api from '../config/functionsApi';
import { PushNotification } from '../models/interfaces/pushNotification';

export default {
  async send(model: PushNotification) {
    return api.post('notifications', model);
  },

  async sendToTokens(tokens: string[], data: any, title: string = '', message: string = '', image: string = '') {
    const payload: PushNotification = {
      tokens,
      title,
      message,
      image,
      data
    };
    return this.send(payload);
  },

  async sendNotificationToDriver(callId: string, header: string, body: string, driverId: string, driverName: string) {
    return addDoc(alertCollection, {
      call: callId,
      createdAt: getDateNow(),
      driver: {
        id: driverId,
        name: driverName
      },
      message: {
        text: body,
        title: header
      },
      type: 'personalnotification'
    });
  },

  async sendSlaExceededToDriver(
    callId: string,
    stageLabel: string,
    clientName: string,
    driverId: string,
    driverName: string
  ) {
    const isWaiting = stageLabel.toLowerCase() === 'aguardando' || stageLabel.toLowerCase() === 'aceite';
    const header = isWaiting
      ? 'Prazo de aceite excedido'
      : `Prazo de ${stageLabel.toLowerCase()} excedido`;
    const body = isWaiting
      ? `A chamada de ${clientName} ainda não foi aceita. Aceite ou inicie o quanto antes.`
      : `O prazo de ${stageLabel.toLowerCase()} da chamada de ${clientName} foi excedido. Dirija-se ao local o quanto antes.`;
    return this.sendNotificationToDriver(callId, header, body, driverId, driverName);
  },

  async sendNotificationToDriverAboutDocs(header: string, body: string, driverId: string, driverName: string) {
    return addDoc(alertCollection, {
      createdAt: getDateNow(),
      driver: {
        id: driverId,
        name: driverName
      },
      message: {
        text: body,
        title: header
      },
      type: 'personalnotification'
    });
  }
};
